import { apiConfig } from './config';
import { useApi } from './use-api-call';

export interface UserLicenseDTO {
    id?: number;
    userId: number;
    userName?: string;
    productId: number;
    productName?: string;
    licenseKey: string;
    licenseCode: string;
    activatedAt?: string;
    expiresAt?: string;
    status: string;
    downloadLink?: string;
    downloadCount: number;
    maxDownloads: number;
    isBroken: boolean;
    brokenReportedAt?: string;
    brokenDescription?: string;
}

export interface UserLicenseSearchResult {
    licenses: UserLicenseDTO[];
    products: Array<{ id: number; name: string }>;
    totalCount: number;
    allowEdit: boolean;
}

export interface UserLicenseSearchRequest {
    userId?: number;
    productId?: number;
    status?: string;
    isBroken?: boolean;
    pageIndex?: number;
    pageSize?: number;
}

// Search user licenses
export const useSearchUserLicensesApi = () =>
    useApi<UserLicenseSearchResult>('/admin/user-licenses/search');

// Update download link
export const useUpdateDownloadLinkApi = () =>
    useApi<{ license: UserLicenseDTO }>('/admin/user-license/update-download-link');

// Reset download count
export const useResetDownloadCountApi = () =>
    useApi<{ license: UserLicenseDTO }>('/admin/user-license/reset-downloads/{licenseId}');

// Update license status
export const useUpdateLicenseStatusApi = () =>
    useApi<{ license: UserLicenseDTO }>('/admin/user-license/update-status');

// Resolve broken license
export const useResolveBrokenLicenseApi = () =>
    useApi<{ license: UserLicenseDTO }>('/admin/user-license/resolve-broken/{licenseId}');

